/* @Deprecated
 * Use DateTimeUnitEnum from libs/date-time-manipulations instead
 */

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use TimeUnitEnum from application-types instead.
 */
export enum TimeUnitEnum {
  Hour = 'hour',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Quarter = 'quarter',
  Year = 'year',
}
